export default "__VITE_ASSET__BAb81gUk__"